<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">Copyright</span></p>
<p class="p1"><span class="t2">Publicado por</span></p>
<p class="p1"><span class="t2">Dreamspinner Press</span></p>
<p class="p1"><span class="t2">382 NE 191</span><span class="t3">st</span><span class="t2"> Street #88329</span></p>
<p class="p1"><span class="t2">Miami, FL 33179-3899, USA</span></p>
<p class="p1"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t4">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p2"><span class="t2">Esta es una obra de ficción. Los nombres, personajes, lugares e incidentes son producto de la imaginación del autor o usados para la ficción y cualquier semejanza con personas vivas o muertas, negocios, eventos o escenarios, es una coincidencia.</span></p>
<p class="p2"><span class="t2">Falling<br/>Copyright © 2010 by D.W. Marchwell</span></p>
<p class="p1"><span class="t2">Portada: Anne Cain </span><span class="t4">annecain.art@gmail.com</span></p>
<p class="p1"><span class="t2">Diseño de portada por Mara McKennen</span></p>
<p class="p1"><span class="t2">Traducido por O.M. Suárez</span></p>
<p class="p3"><span class="t2">La licencia de este libro pertenece exclusivamente al comprador original. Duplicarlo o reproducirlo por cualquier medio es ilegal y una violación de la Ley de Derechos de Autor Internacional. Este eBook no puede ser prestado legalmente o regalado a otros. Ninguna parte de este eBook puede ser compartida o reproducida sin el permiso expreso de la editorial. Para solicitar el permiso y resolver cualquier duda, contacta con Dreamspinner Press 382 NE 191st Street #88329, Miami, FL 33179-3899, USA </span><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t4">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p2"><span class="t2">Publicado en los Estados Unidos de América</span></p>
<p class="p2"><span class="t2">Primera Edición</span></p>
<p class="p1"><span class="t2">Febrero de 2010</span></p>
<p class="p1"><span class="t2">Edición eBook en Español: 978-1-61372-844-4</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?4220eb36